import Cookies from 'js-cookie'
import anime from 'animejs'

export default class Notice {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
    this.bindEvents()
  }

  setVars() {
    const { dataset } = this.el
    this.closeTrigger = this.el.querySelectorAll('[data-notice-dismiss]')
    this.rememberState = dataset.remember
    this.cookieName = dataset.cookieName ?? 'noticeOpen'
    this.cookieVisibleValue = dataset.visibleValue ?? 'visible'
    this.cookieHiddenValue = dataset.hiddenValue ?? 'hidden'
    this.noticeOpen = Cookies.get(this.cookieName)
    this.mode = dataset.animateMode ?? 'default'
  }

  init() {
    if (this.rememberState !== 'true') {
      return
    }
    if (typeof this.noticeOpen === 'undefined') {
      this.el.classList.add('visible')
      this.updateCookie(this.cookieVisibleValue)
    } else if (this.noticeOpen !== 'visible') {
      this.el.classList.add('hidden')
      this.el.classList.remove('visible')
    } else {
      this.revealNotice(this.el)
    }
  }

  bindEvents() {
    this.closeTrigger.forEach((element) => {
      element.addEventListener('click', this.handleLinkClick.bind(this))
    })
  }

  updateCookie(status) {
    if (this.rememberState === 'true') {
      Cookies.set(this.cookieName, status, { expires: 1 })
      this.noticeOpen = status
    }
  }

  revealNotice() {
    const { classList } = this.el
    if (classList.contains('hidden')) {
      const endHeight = this.getNoticeHeight()
      classList.remove('hidden')
      anime({
        targets: this.el,
        easing: 'linear',
        height: [0, `${endHeight}px`],
        duration: 350,
        complete(anim) {
          classList.add('visible')
        },
      })
    } else {
      this.el.classList.add('visible')
    }
  }

  getNoticeHeight = () => {
    const {
      classList,
      offsetHeight,
    } = this.el
    const wasHidden = classList.contains('hidden')

    if (wasHidden) {
      classList.add('visible', 'opacity-0', 'absolute')
      classList.remove('hidden')
    }

    const height = offsetHeight

    if (wasHidden) {
      classList.add('hidden')
      classList.remove('visible', 'opacity-0', 'absolute')
    }

    return height
  }

  handleLinkClick() {
    if (this.mode === 'slide-out') {
      this.animateSlideOut()
    } else {
      this.animateDefault()
    }
    if (this.rememberState === 'true') {
      this.updateCookie(this.cookieHiddenValue)
    }
  }

  animateDefault() {
    const height = this.getNoticeHeight()
    anime({
      targets: this.el,
      easing: 'easeInOutSine',
      height: [height, 0],
      opacity: [1, 0],
      duration: 300,
      complete: this.#handleAnimationComplete,
    })
  }

  animateSlideOut() {
    anime({
      targets: this.el,
      translateY: [0, '100%'],
      opacity: [1, 0],
      easing: 'easeInOutSine',
      duration: 300,
      complete: this.#handleAnimationComplete,
    })
  }

  // Private methods
  // @DEV new to me, this is a ES2019 private class syntax.
  #handleAnimationComplete = () => {
    const {
      classList,
      style,
    } = this.el
    classList.add('hidden')
    classList.remove('visible')
    if (this.mode === 'slide-out') {
      style.transform = ''
      style.opacity = ''
    }
  }
}
